<script lang="ts">
  import BackBtn from '$lib/components/common/BackBtn.svelte';
  import Loading from '$lib/components/Loading.svelte';
  import CategorySkillListGrid from '$lib/components/student/CategorySkillListGrid.svelte';
  import type { PageProps } from './$types';

  // skills progress; shows all skills for each category of the class, with a checkmark next to the ones that have been
  // completed

  let { data }: PageProps = $props();
</script>

<BackBtn />

{#await data.classPromise}
  <Loading />
{:then leaderboard}
  <CategorySkillListGrid
    classId={leaderboard.classId}
    classEndDate={leaderboard.class.endDate}
    classStartDate={leaderboard.class.startDate}
    categories={leaderboard.class.course.skillCategories}
    skills={leaderboard.skills}
    badgeProgressItems={leaderboard.badgeProgress}
  />
{/await}
